<template>
  <ComponentCard :title="shape.title" :icon="shape.icon">
    <BlockField v-if="shape.hasTitle" :model-value="attrs.title" placeholder="Title" :read-only="readOnly" input-class="text-sm font-bold text-[#1c4848]" @update:model-value="set({ title: $event })" />
    <div v-for="(item, i) in attrs.items" :key="i" class="flex items-start gap-2 rounded-xl bg-[#1c4848]/[0.03] p-2">
      <span v-if="shape.numbered" class="mt-1.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#1c4848] text-[11px] font-bold text-white">{{ i + 1 }}</span>
      <div class="min-w-0 flex-1 space-y-1">
        <BlockField v-for="field in shape.fields" :key="field.key" :model-value="item[field.key]" :placeholder="field.placeholder" :read-only="readOnly" :input-class="field.style" @update:model-value="list.patch(i, { [field.key]: $event })" />
      </div>
      <RowActions v-if="!readOnly" :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
    </div>
    <button v-if="!readOnly" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add(shape.blank)">+ {{ shape.add }}</button>
  </ComponentCard>
</template>

<script setup>
import { computed } from 'vue';
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const STRONG = 'text-sm font-bold text-[#1c4848]';
const BODY = 'text-sm leading-relaxed text-[#1c4848]/85';

const SHAPES = {
  steps: {
    title: 'Steps', icon: 'solar:sort-by-time-linear', hasTitle: true, numbered: true, add: 'Add a step', blank: { title: '', text: '' },
    fields: [{ key: 'title', placeholder: 'Step', style: STRONG }, { key: 'text', placeholder: 'What to do', style: BODY }],
  },
  timeline: {
    title: 'Timeline', icon: 'solar:history-linear', add: 'Add an event', blank: { date: '', title: '', text: '' },
    fields: [{ key: 'date', placeholder: 'When, like 622 CE', style: 'text-xs font-bold text-[#a0833c]' }, { key: 'title', placeholder: 'What happened', style: STRONG }, { key: 'text', placeholder: 'More about it', style: BODY }],
  },
  qa: {
    title: 'Questions', icon: 'solar:question-circle-linear', add: 'Add a question', blank: { question: '', answer: '' },
    fields: [{ key: 'question', placeholder: 'Question', style: STRONG }, { key: 'answer', placeholder: 'Answer', style: BODY }],
  },
};

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
const shape = computed(() => SHAPES[props.kind]);
</script>
